module.exports = __webpack_public_path__ + "img/ALL.78ccd820.svg";